import React from 'react';
import MoveToInboxOutlinedIcon from '@mui/icons-material/MoveToInboxOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import PercentOutlinedIcon from '@mui/icons-material/PercentOutlined';
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import StatCard from '../components/StatCard';
import ChartBlock from '../components/ChartBlock';
import TimelineChart from '../components/TimelineChart';
import RankList from '../components/RankList';
import Funnel from '../components/Funnel';
import styles from '../components/stats.module.css';
import palette from '../components/palette';
import { GetChannelFriendlyName } from '../../../consts/LeadsConfig';
import { formatNumber, formatPercent, granularityHint } from '../utils/format';

export const LEAD_CARDS = [
  { key: 'received', label: 'Leads recebidos', icon: <MoveToInboxOutlinedIcon />, accent: 'blue' },
  { key: 'converted', label: 'Viraram pacientes', icon: <HowToRegOutlinedIcon />, accent: 'green' },
  { key: 'conversionRate', label: 'Taxa de conversão', icon: <PercentOutlinedIcon />, type: 'percent', accent: 'green' },
  { key: 'open', label: 'Ainda em aberto', icon: <HourglassEmptyOutlinedIcon />, accent: 'amber' },
  { key: 'daysToConvert', label: 'Tempo até converter', icon: <TimerOutlinedIcon />, type: 'days', inverse: true, accent: 'purple' },
  { key: 'revenue', label: 'Faturado com eles', icon: <PaymentsOutlinedIcon />, type: 'money', accent: 'teal', hint: 'pagamentos dos pacientes convertidos' },
];

export const funnelSteps = (funnel) => [
  { label: 'Recebidos', value: funnel.received, color: palette.blue },
  { label: 'Contatados', value: funnel.contacted, color: palette.purple },
  { label: 'Viraram pacientes', value: funnel.converted, color: palette.green },
];

const conversionItems = (list, labelOf) => list.map((item) => ({
  label: labelOf(item),
  value: item.received,
  display: formatNumber(item.received),
  sub: `${formatNumber(item.converted)} convertidos (${formatPercent(item.rate)})`,
}));

export const channelItems = (byChannel) => conversionItems(byChannel, (item) => GetChannelFriendlyName(item.channel));
export const campaignItems = (byCampaign) => conversionItems(byCampaign, (item) => (item.source ? `${item.campaign} · ${item.source}` : item.campaign));

const LeadsSection = ({ data, granularity }) => (
  <>
    <div className={styles.grid}>
      {LEAD_CARDS.map((card) => <StatCard key={card.key} {...card} kpi={data.kpis[card.key]} />)}
    </div>

    <div className={styles.rowEven}>
      <ChartBlock title="Funil" hint={data.funnel.lost ? `${formatNumber(data.funnel.lost)} perdidos` : ''}>
        <Funnel steps={funnelSteps(data.funnel)} />
      </ChartBlock>
      <ChartBlock title="Chegada de leads" hint={granularityHint(granularity)}>
        <TimelineChart
          data={data.timeline}
          granularity={granularity}
          series={[
            { key: 'received', label: 'Recebidos', color: palette.blue },
            { key: 'converted', label: 'Convertidos', color: palette.green },
          ]}
          height={200}
        />
      </ChartBlock>
    </div>

    <div className={styles.rowEven}>
      <ChartBlock title="Por canal">
        <RankList items={channelItems(data.byChannel)} color={palette.blue} empty="Nenhum lead no período." />
      </ChartBlock>
      <ChartBlock title="Por campanha">
        <RankList items={campaignItems(data.byCampaign)} color={palette.pink} empty="Nenhum lead no período." />
      </ChartBlock>
    </div>
  </>
);

export default LeadsSection;
